<template>
    <div class="addSalesman">
        <headerNotice routerName="修改业务员"></headerNotice>
        <div class="addSalesmanContent" :v-loading="loading">
            <div class="editTitle">
                <h2>基本信息</h2>
            </div>
            <el-form
                :inline="false"
                ref="editSalesmanForm"
                :model="addSalesmanForm"
                label-width="120px"
                class="addSalesmanForm"
            >
                <div class="formLeft">
                    <el-form-item label="业务员姓名" :rules="{required:true}">
                        <el-input v-model="addSalesmanForm.realName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" :rules="{required:true}">
                        <el-input v-model="addSalesmanForm.phone" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="Email" :rules="{required:true}">
                        <el-input v-model="addSalesmanForm.eMail" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="微信">
                        <el-input v-model="addSalesmanForm.weiXin" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="QQ">
                        <el-input v-model="addSalesmanForm.qq" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formRight">
                    <el-upload
                        :accept='accept'
                        :headers="headers"
                        class="avatar-uploader avatarBox"
                        :action="uploadAction"
                        :show-file-list="false"
                        :on-success="handleAddSuccess"
                        :before-upload="beforeUpload"
                    >
                        <img
                            v-if="addSalesmanForm.headImgUrl"
                            :src="baseUrl+addSalesmanForm.headImgUrl"
                            class="avatar"
                        >
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip avatarTip">上传头像</div>
                        <div slot="tip" class="el-upload__tip uploadTip">只能上传图片，且不超过1M，建议尺寸400*400px</div>
                    </el-upload>
                </div>
            </el-form>
            <div class="editTitle">
                <h2>业务员账户</h2>
            </div>
            <el-form
                :inline="false"
                ref="addSalesmanForm"
                :model="addSalesmanForm"
                label-width="120px"
                class="addSalesmanForm"
            >
                <div class="formLeft">
                    <el-form-item label="账号">
                        <el-input v-model="addSalesmanForm.userName" :readonly="true"></el-input>
                    </el-form-item>
                    <!-- 暂时不显示 -->
                    <el-form-item label="密码">
                        <el-input type="password" v-model="addSalesmanForm.password" readonly placeholder="******">
                            <el-button @click='resetPassword' type="primary" slot="append">重置密码</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if='tipsFlag' style="margin-left: 30px;">
                        <span>密码已重置为：yth123456</span>
                    </el-form-item>
                    <el-form-item label="账号状态">
                        <el-radio-group v-model="addSalesmanForm.status">
                            <el-radio :label="1">开通</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveEdit">保存</el-button>
                        <el-button @click="onCancle">取消</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadHeadImg',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            loading: true,
            tipsFlag: 0,
            addSalesmanForm: {
                realName: '',
                userName: '',
                phone: '',
                eMail: '',
                qq: '',
                weiXin: '',
                headImgUrl: '',
                userID: '',
                password: '',
                status: ''
            },
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        //从路由提取userID
        this.onSalesmanDetail(this.$route.query);
    },
    methods: {
        resetPassword() {
            let self = this;
            let search = `?userId=${this.addSalesmanForm.userID}`
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminUser/ResetUserPassword" + search,
                success(res) {
                    self.$message.success('密码重置成功')
                    self.tipsFlag = 1
                },
                fail(res) {
                }
            })
        },
        //上传图片之前
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                this.$message.error('上传的图片只支持JPG/PNG/GIF 的格式!');
                return false;
            }
            return true;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        //上传图片到服务器
        handleImageAdded: function (file, Editor, cursorLocation) {
            let self = this;
            var formDatas = new FormData();
            formDatas.append('image', file);
            $http.POST({
                url: this.$store.state.urlApi + '/api/services/app/Upload/UploadDetailImage',
                method: 'POST',
                data: formDatas,
                success(res) {
                    self.addSalesmanForm.headImgUrl = response.result.data;
                },
                fail() {

                }
            })
        },
        //图片上传成功
        handleAddSuccess(response, file, fileList) {
            this.addSalesmanForm.headImgUrl = response.result.data;
            // this.headImgUrl = URL.createObjectURL(file.raw);
        },
        //打开查看详情弹窗
        onSalesmanDetail(row) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetInfo",
                params: { userId: row.userId },
                success(res) {
                    self.addSalesmanForm = res;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //保存修改
        saveEdit() {
            let self = this;
            if (!this.addSalesmanForm.realName) {
                this.$message.error('请填写业务员姓名！');
                return;
            }
            if (!this.addSalesmanForm.eMail) {
                this.$message.error('请填写邮箱！');
                return;
            }
            if (this.addSalesmanForm.phone.length != 11) {
                this.$message.error('请填写正确手机号！');
                return;
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSalesman/ModifyInfo",
                data: this.addSalesmanForm,
                success(res) {
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                    self.$router.push({
                        'path': '/salesman',
                    })
                },
                fail(res) {
                    self.$message({
                        message: res.data,
                        type: 'warning'
                    });
                }
            })
        },
        onCancle() {
            this.$router.push({
                'path': '/salesman',
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.addSalesman {
    .addSalesmanContent {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .editTitle {
            height: 40px;
            line-height: 40px;
            align-self: normal;
            margin-bottom: 10px;
            padding-left: 20px;
            border-bottom: 1px solid #c5c5c5;
        }
        .addSalesmanForm {
            display: flex;
            .formLeft {
                margin-right: 20px;
            }
            .formRight {
                margin-left: 20px;
            }
        }
        .avatarBox {
            margin-top: 50px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .avatarTip {
                color: #1abc9c;
            }
            .uploadTip {
                padding-top: 10px;
                padding-bottom: 20px;
            }
        }
    }
}
</style>
<style lang="scss">
.addSalesman {
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>    